import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo, useMemo } from "react";

interface NumberBadgeProps {
  value: number | string;
  className?: string;
}

export const NumberBadge = memo(function NumberBadge({ value, className }: NumberBadgeProps) {
  const valueList = useMemo(() => value.toString().split(""), [value]);
  return (
    <span className="inline-flex items-center">
      {valueList.map((digit, index) => (
        <span
          key={`${value}-${digit}-${index}`}
          className={cn(
            textVariants.title2,
            "bg-[#2C2C2C] p-2 font-bold text-white",
            "first:rounded-l-lg last:rounded-r-lg",
            className,
          )}
        >
          {digit}
        </span>
      ))}
    </span>
  );
});
